module.exports = __webpack_public_path__ + "img/img_kb_type2_slide02.210f12a5.png";